import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  ExtractFacebookLeadFormQuery,
  ExtractFacebookLeadFormQueryVariables
} from './__generated__/ExtractFacebookLeadFormQuery';

const EXTRACT_LEAD_FORM_QUERY = gql`
  query ExtractFacebookLeadFormQuery($externalId: ID!) {
    extractFacebookLeadgenForm(externalId: $externalId)
  }
`;

export const useExtractLeadFormLazyQuery = () => {
  return useLazyQuery<ExtractFacebookLeadFormQuery, ExtractFacebookLeadFormQueryVariables>(EXTRACT_LEAD_FORM_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first'
  });
};
